import type { ApiClient } from '@sl/core';
import { identityRequest, type Identity } from '../../routes/acquisition/identity';

/** Keep the signed-in person when an API build is exploring the sample shop. */
export function withSessionIdentity(client: ApiClient): ApiClient {
  return new Proxy(client, {
    get(target, key, receiver) {
      if (key === 'getSession')
        return async () => {
          const response = await target.getSession();
          const user = response.data.user;
          if (target.transport !== 'demo' && user.displayName?.trim() && user.displayName !== 'You')
            return response;
          try {
            const identity = await identityRequest<Identity | { authenticated: false }>(
              'session?optional=true',
            );
            if (!('email' in identity)) return response;
            // A real workspace remains bound to its server user. Demo ad data is independent of identity.
            if (target.transport !== 'demo' && identity.userId !== user.id) return response;
            return {
              ...response,
              data: {
                ...response.data,
                user: {
                  ...user,
                  id: identity.userId || user.id,
                  displayName:
                    identity.displayName?.trim() || identity.email?.trim() || 'Your account',
                },
              },
            };
          } catch {
            // A temporary identity-service failure must not prevent exploring sample campaigns.
            return response;
          }
        };
      const value = Reflect.get(target, key, receiver);
      return typeof value === 'function' ? value.bind(target) : value;
    },
  });
}
